import classNames from "classnames";
import React, { useContext } from "react";
import { FormattedMessage } from "react-intl";

import IconEdit from "../../../public/svg/icon-edit.svg";
import { ThemeContext } from "../../contexts/ThemeContext";

import css from "./SeasonPassPhotoUpload.module.scss";

export const TEST_ID_PLACEHOLDER_IMAGE = "photoupload-placeholder-image";
export const TEST_ID_PHOTO = "photoupload-photo";
export const TEST_ID_PHOTO_INPUT = "photoupload-photo-input";

interface SeasonPassPhotoUploadProps {
  photo?: string;
  isLoading: boolean;
  onChange: (ev: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus: React.FocusEventHandler<HTMLInputElement>;
  error?: string;
}

const SeasonPassPhotoUpload: React.FC<SeasonPassPhotoUploadProps> = ({
  photo,
  isLoading,
  onChange,
  onFocus,
  error,
}) => {
  const { styles } = useContext(ThemeContext);

  return (
    <div className="pb4">
      <div className="flex flex-wrap-reverse flex-wrap-ns items-center pt3">
        <label className={classNames("pr4", css.inputWrapper)}>
          <input
            type="file"
            accept="image/*"
            onChange={onChange}
            onFocus={onFocus}
            disabled={isLoading}
            data-testid={TEST_ID_PHOTO_INPUT}
          />
          <div className={classNames("relative dib", css.photoWrapper)}>
            {photo ? (
              <picture>
                <img
                  className={classNames("br-100", css.photoImg)}
                  src={photo}
                  alt=""
                  aria-label="Your photo"
                  data-testid={TEST_ID_PHOTO}
                />
              </picture>
            ) : (
              <picture>
                <img
                  className={classNames("br-100", css.photoImg)}
                  src="/images/seasonpass-photo-placeholder.png"
                  alt=""
                  aria-label="Placeholder for your photo"
                  data-testid={TEST_ID_PLACEHOLDER_IMAGE}
                />
              </picture>
            )}
            <div
              className={classNames(
                "flex items-center justify-center absolute top-2 right-0 white bg-black br-100 svg-icon-small",
                css.iconWrapper,
              )}
            >
              <IconEdit />
            </div>
          </div>
        </label>
        <div>
          <h3 className={`${styles.paragraph1} mv0`}>
            <FormattedMessage id="seasonpass.photoUpload.title" />
          </h3>
          <p className={`${styles.paragraph2} dark-gray mt1`}>
            <FormattedMessage id="seasonpass.photoUpload.description" />
          </p>
        </div>
      </div>
      {error && <p className={`${styles.paragraph3} red mv0`}>{error}</p>}
    </div>
  );
};

export default SeasonPassPhotoUpload;
